import { SET_HEADER_SEARCH, CLEAR_HEADER_SEARCH, CREDIT_MODAL, AUTH_MODAL } from '../types/header.type'

const intialState = {
  search: '',
  clear: false,
  enableAddonModal: false,
  enableAuthModal: false,
  LeftSideBarToggle: false,
}

const headerReducer = (state = intialState, action) => {
  switch (action.type) {
    case SET_HEADER_SEARCH:
      return { ...state, search: action.payload, clear: false }
    case CLEAR_HEADER_SEARCH:
      return { ...state, search: null, clear: true }
    case CREDIT_MODAL:
      return { ...state, ...action.payload }
    case AUTH_MODAL:
      return { ...state, enableAuthModal: action.payload }
    default:
      return state
  }
}

export default headerReducer
